import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './KycVerification.css'; // Ensure this CSS file exists
import { toast } from 'react-toastify';

const KYCVerificationPage = () => {
  const { authData } = useAuth();
  const { isKycCompleted, trialTime } = authData;
  const navigate = useNavigate();

  // Handle redirection based on KYC and trial status
  useEffect(() => {
    if (authData && isKycCompleted === true && trialTime > 0) {
      //console.log('User has active trial and KYC completed. Redirecting to dashboard...');
      navigate('/dashboard');
    }

    if (authData && isKycCompleted === true && trialTime === 0) {
      //console.log('Test KYCVerificationPage');
      //navigate('/setup-hotel');
    }
  }, [authData, isKycCompleted, trialTime, navigate]);

  // Debugging log to check if the page is loading
  useEffect(() => {
    //console.log('KYCVerificationPage loaded');
    //console.log('KYC Status:', isKycCompleted);
  }, [isKycCompleted]);

  const handleResubmit = () => {
    toast.info('Redirecting to KYC Upload page...');
  };

  return (
    <div className="kyc-verification-container">
      <h2>Owner Verification Status</h2>
      <div className="status-card">
        {isKycCompleted === 2 ? (
          <div className="status approved">
            <h3>KYC Approved</h3>
            <p>Your KYC has been successfully verified.</p>
          </div>
        ) : isKycCompleted === 3 ? (
          <div className="status rejected">
            <h3>KYC Rejected</h3>
            <p>Your KYC submission was rejected. Please resubmit your documents.</p>
            <Link to="/kyc-upload" className="upload-link" onClick={handleResubmit}>
              Resubmit Documents
            </Link>
          </div>
        ) : (
          <div className="status pending">
            <h3>User Verification Pending</h3>
            <p>Your verification is currently under review. Please wait for approval.</p>
            <Link to="/kyc-upload" className="upload-link">
              Upload your Documents
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default KYCVerificationPage;
